import './styles.scss';

type Props = {
    children: React.ReactNode
}

export const FormGroup: React.FC<Props> = ({children}: Props) => (
    <div className='vs-form-group'>{children}</div>
);
